import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  // Screen layout
  container: {
    flex: 1,
    backgroundColor: "#FFFFFF",
    minWidth: 0,
  },
  contentContainer: {
    flex: 1,
    minWidth: 0,
  },

  // Header
  header: {
    height: 60,
    backgroundColor: "#FFFFFF",
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#EEEEEE",
    zIndex: 20,
    elevation: 20,
    overflow: "visible",
  },
  headerTitleContainer: {
    flex: 1,
    minWidth: 0,
    overflow: "visible",
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: "500",
    color: "#333333",
  },
  headerLink: {
    color: "#333333",
    fontWeight: "500",
  },
  headerBold: {
    fontWeight: "700",
  },
  headerRightControls: {
    flexDirection: "row",
    alignItems: "center",
  },
  viewSelectorButton: {
    minHeight: 36,
    minWidth: 128,
    paddingHorizontal: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#C4C6CD",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#FFFFFF",
  },
  viewSelectorButtonText: {
    fontFamily: "Urbanist500",
    fontSize: 14,
    lineHeight: 20,
    color: "#1F2937",
    marginRight: 8,
  },
  viewSelectorModalBackdrop: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.08)",
  },
  viewSelectorMenu: {
    position: "absolute",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#E5E7EB",
    backgroundColor: "#FFFFFF",
    paddingVertical: 6,
    shadowColor: "#000000",
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.12,
    shadowRadius: 20,
    elevation: 24,
  },
  viewSelectorMenuItem: {
    minHeight: 44,
    justifyContent: "center",
    paddingHorizontal: 12,
    borderRadius: 8,
    marginHorizontal: 6,
  },
  viewSelectorMenuItemSelected: {
    backgroundColor: "#EAF7FF",
  },
  viewSelectorMenuItemText: {
    fontFamily: "Urbanist500",
    fontSize: 14,
    lineHeight: 20,
    color: "#111827",
  },
  viewSelectorMenuItemTextSelected: {
    color: "#0A6FD6",
  },

  // Floating action button
  quickRecordFab: {
    position: "absolute",
    right: 20,
    bottom: 20,
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: "#0A6FD6",
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 8,
    zIndex: 1000,
  },
});

export default styles;
